import { createModel } from "@rematch/core";
import { CustomerType, EffectsColumnsDataState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState = {
  effectsColumnsData: [],
};

export const effectsColumnsData = createModel<RootModel>()({
  state: initialState as EffectsColumnsDataState,
  reducers: {
    fetchSuccess(
      state,
      payload: {
        columnName: string;
        columns: string[];
      }[]
    ) {
      return {
        ...state,
        effectsColumnsData: payload,
      };
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchColumnsData(customerType: CustomerType, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.effectsColumnsData.fetchFail()
      );
      if (!token) return;

      try {
        const effectsColumnsDataResult = await api.fetchEffectsColumns(
          token,
          customerType
        );
        dispatch.effectsColumnsData.fetchSuccess(effectsColumnsDataResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.effectsColumnsData.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/effectsColumnsData.ts